export { default } from './resolveComponentProps';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/resolveComponentProps/index.js
// module id = 450
// module chunks = 25